import type { BackoffPolicy } from '../types';

export const defaultBackoffPolicy: BackoffPolicy = {
  maxAttempts: 6,
  nextDelayMs: (attempt) => {
    const base = Math.min(30_000, 1000 * 2 ** Math.max(0, attempt - 1));
    const jitter = Math.random() * 0.3 * base;
    return Math.floor(base + jitter);
  },
};
